import React, {useContext, useEffect, useState} from 'react';
import Typography from '@material-ui/core/Typography';
import {fade, makeStyles} from '@material-ui/core/styles';
import AppContext from '../../Services/AppContext';
import PersistantData from '../../Services/PersistantData';
import Button from '@material-ui/core/Button';
import {useCommonStyles} from '../../Styles';
import {
	ck_u_password,
	ck_u_username,
	defDateFormat,
	empty,
	req_cust,
	req_salesman,
	req_survey_forms,
	req_survey_submission,
	req_survey_submission_report_download,
	req_survey_rotateimage,
} from '../../Helper/Constants';
import _ from 'lodash';
import JString from '@easytech-international-sdn-bhd/jstring';
import API_Service, {axiosDefaultConfig, axiosURIencode} from '../../Services/API_Service';
import {useSnackbar} from 'notistack';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import DateRangePickerModal from '../../Components/DateRangePickerModal';
import moment from 'moment';
import VirtualListCB from '../../Components/VirtualListCB';
import format from 'date-fns/format';
import useCookieHook from "../../Services/useCookieHook";
import useColumnPreference from '../../Services/useColumnPreference';
import PhotoViewer from '../../Components/PhotoViewer';
import MUIDataTable from 'mui-datatables';
import { Dialog, DialogContent, Card, Tooltip, SvgIcon, IconButton, Chip, CircularProgress } from '@material-ui/core';
import { Rating } from '@material-ui/lab';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import SubjectIcon from '@material-ui/icons/Subject';
import StarRateRoundedIcon from '@material-ui/icons/StarRateRounded';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import PhotoLibraryOutlinedIcon from '@material-ui/icons/PhotoLibraryOutlined';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import DoneRoundedIcon from '@material-ui/icons/DoneRounded';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const CheckInIcon = (props) => (
	<SvgIcon {...props}>
		<path d="M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z"/>
	</SvgIcon>
);

const CheckOutIcon = (props) => (
	<SvgIcon {...props}>
		<path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
	</SvgIcon>
);

const useStyles = makeStyles((theme) => {
	const onAccent = theme.palette.getContrastText(theme.palette.primary.main);
	const surface2 = theme.palette.type === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)';
	return ({
	viewInRow: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'left',
		marginTop: theme.spacing(1),
		rowGap: 10
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightMedium,
	},
	dateBtn: {
		width: '100%',
		marginTop: theme.spacing(1)
	},
	filterBtn: {
		width: 300,
		marginRight: 10
	},
	dialogPaper: {
		borderRadius: 14,
		overflow: 'hidden'
	},
	dhead: {
		flexShrink: 0,
		display: 'flex',
		alignItems: 'flex-start',
		gap: theme.spacing(1.75),
		padding: theme.spacing(2.25, 2.5, 2),
		borderBottom: `1px solid ${theme.palette.divider}`,
		background: `linear-gradient(135deg, ${fade(theme.palette.primary.main, theme.palette.type === 'dark' ? 0.16 : 0.42)}, ${fade(theme.palette.primary.main, 0)} 70%)`
	},
	headBadge: {
		flex: '0 0 auto',
		width: 42,
		height: 42,
		borderRadius: 11,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: theme.palette.primary.main,
		color: onAccent,
		'& svg': {
			display: 'block',
			fontSize: 23
		}
	},
	headText: {
		flex: 1,
		minWidth: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		paddingTop: 1
	},
	headTitle: {
		fontSize: '1.125rem',
		fontWeight: 700,
		lineHeight: 1.25,
		color: theme.palette.text.primary
	},
	headSub: {
		color: theme.palette.text.secondary,
		fontWeight: 500,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap'
	},
	closeBtn: {
		flex: '0 0 auto',
		color: theme.palette.text.secondary,
		'& .MuiIconButton-label': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center'
		},
		'& svg': {
			display: 'block'
		}
	},
	strip: {
		flexShrink: 0,
		display: 'flex',
		flexWrap: 'wrap',
		padding: theme.spacing(0.5, 1),
		borderRadius: 12,
		border: `1px solid ${theme.palette.divider}`,
		backgroundColor: surface2
	},
	cell: {
		flex: '1 1 150px',
		minWidth: 0,
		padding: theme.spacing(1.25, 1.5),
		position: 'relative',
		'&:not(:first-child)::before': {
			content: '""',
			position: 'absolute',
			left: 0,
			top: 12,
			bottom: 12,
			width: 1,
			backgroundColor: theme.palette.divider
		}
	},
	cellLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: 5,
		marginBottom: 5,
		fontSize: 10.5,
		fontWeight: 600,
		letterSpacing: '0.12em',
		textTransform: 'uppercase',
		color: theme.palette.text.secondary,
		'& svg': {
			display: 'block',
			fontSize: 13
		}
	},
	cellValue: {
		fontSize: 14,
		fontWeight: 500,
		lineHeight: 1.35,
		color: theme.palette.text.primary
	},
	cellValueClamp: {
		display: '-webkit-box',
		WebkitLineClamp: 2,
		WebkitBoxOrient: 'vertical',
		overflow: 'hidden'
	},
	cellCode: {
		display: 'inline-block',
		marginTop: 5,
		padding: '1px 7px',
		borderRadius: 5,
		fontSize: 11,
		fontWeight: 600,
		letterSpacing: '0.02em',
		color: theme.palette.text.secondary,
		backgroundColor: surface2,
		border: `1px solid ${theme.palette.divider}`
	},
	cellSub: {
		display: 'block',
		marginTop: 3,
		fontSize: 12.5,
		fontWeight: 500,
		color: theme.palette.text.secondary
	},
	dbody: {
		flex: '1 1 auto',
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing(1.75),
		padding: theme.spacing(2, 2.5, 2.5)
	},
	'@keyframes cardIn': {
		from: {opacity: 0, transform: 'translateY(10px)'},
		to: {opacity: 1, transform: 'none'}
	},
	qCard: {
		flexShrink: 0,
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: 12,
		backgroundColor: theme.palette.background.paper,
		boxShadow: 'none',
		transition: 'box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease',
		animation: '$cardIn 0.38s ease both',
		'&:hover': {
			transform: 'translateY(-1px)',
			borderColor: fade(theme.palette.primary.main, 0.45),
			boxShadow: `0 4px 16px ${fade(theme.palette.primary.main, 0.10)}`
		},
		'&:nth-child(1)': {animationDelay: '0.04s'},
		'&:nth-child(2)': {animationDelay: '0.11s'},
		'&:nth-child(3)': {animationDelay: '0.18s'},
		'&:nth-child(4)': {animationDelay: '0.25s'},
		'&:nth-child(5)': {animationDelay: '0.32s'},
		'&:nth-child(6)': {animationDelay: '0.39s'},
		'&:nth-child(7)': {animationDelay: '0.46s'},
		'&:nth-child(8)': {animationDelay: '0.53s'},
		'@media (prefers-reduced-motion: reduce)': {
			animation: 'none',
			transition: 'none'
		}
	},
	qHead: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: theme.spacing(1.375),
		padding: theme.spacing(1.625, 1.875, 0)
	},
	qNum: {
		flex: '0 0 auto',
		minWidth: 30,
		height: 24,
		marginTop: 1,
		padding: theme.spacing(0, 1),
		borderRadius: 7,
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: theme.palette.primary.main,
		color: onAccent,
		fontWeight: 700,
		fontSize: 12.5
	},
	qText: {
		flex: 1,
		minWidth: 0,
		fontWeight: 600,
		fontSize: 15,
		lineHeight: 1.4,
		color: theme.palette.text.primary
	},
	qType: {
		flex: '0 0 auto',
		display: 'inline-flex',
		alignItems: 'center',
		gap: 5,
		marginTop: 3,
		fontSize: 11,
		fontWeight: 600,
		letterSpacing: '0.06em',
		textTransform: 'uppercase',
		color: theme.palette.text.disabled,
		'& svg': {
			display: 'block',
			fontSize: 15
		}
	},
	qTypeLabel: {
		[theme.breakpoints.down('xs')]: {
			display: 'none'
		}
	},
	qAns: {
		margin: theme.spacing(1.375, 1.5, 1.5),
		padding: theme.spacing(1.625, 1.875),
		borderRadius: 9,
		backgroundColor: surface2,
		border: `1px solid ${theme.palette.divider}`
	},
	ansText: {
		margin: 0,
		fontSize: 14.5,
		lineHeight: 1.6,
		color: theme.palette.text.primary,
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-word'
	},
	ansEmpty: {
		display: 'flex',
		alignItems: 'center',
		gap: 7,
		fontSize: 13.5,
		fontStyle: 'italic',
		color: theme.palette.text.disabled,
		'& svg': {
			display: 'block',
			fontSize: 16
		}
	},
	rating: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(1.5)
	},
	rScore: {
		fontSize: 14,
		color: theme.palette.text.secondary,
		'& b': {
			color: theme.palette.text.primary,
			fontWeight: 700,
			fontSize: 16
		}
	},
	choices: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: theme.spacing(1)
	},
	choiceChip: {
		height: 30,
		borderRadius: 999,
		fontSize: 13.5,
		fontWeight: 500,
		color: theme.palette.text.primary,
		backgroundColor: theme.palette.action.selected,
		'& .MuiChip-icon': {
			color: theme.palette.text.secondary,
			marginLeft: 6
		}
	},
	photos: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: theme.spacing(1.5)
	},
	photoCount: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		gap: 6,
		marginBottom: 2,
		fontSize: 12,
		fontWeight: 500,
		color: theme.palette.text.secondary,
		'& svg': {
			display: 'block',
			fontSize: 15
		}
	},
	thumb: {
		position: 'relative',
		width: 132,
		height: 132,
		flex: '0 0 auto',
		borderRadius: 10,
		overflow: 'hidden',
		cursor: 'pointer',
		border: `1px solid ${theme.palette.divider}`,
		backgroundColor: '#0e0e10',
		transition: 'transform 0.2s ease, box-shadow 0.2s ease',
		'& img': {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
			display: 'block'
		},
		'&:hover': {
			transform: 'scale(1.03)',
			borderColor: fade(theme.palette.primary.main, 0.45),
			boxShadow: `0 4px 16px ${fade(theme.palette.primary.main, 0.12)}`
		},
		'&:hover $thumbOverlay': {
			opacity: 1
		},
		[theme.breakpoints.down('xs')]: {
			width: 'calc(50% - 6px)',
			height: 120
		}
	},
	thumbOverlay: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(10,10,12,0.46)',
		color: '#fff',
		opacity: 0,
		transition: 'opacity 0.2s ease',
		'& svg': {
			display: 'block',
			fontSize: 30
		}
	},
	btnPrimary: {
		flexShrink: 0,
		whiteSpace: 'nowrap',
		backgroundColor: theme.palette.primary.main,
		color: onAccent,
		fontWeight: 600,
		boxShadow: '0 2px 8px rgba(254,242,0,0.25)',
		'&:hover': {
			backgroundColor: theme.palette.primary.main,
			filter: 'brightness(1.04)',
			boxShadow: '0 4px 14px rgba(254,242,0,0.35)'
		}
	}
	});
});

const tableHead = (language) => [
    {
        name: "agent_code",
        label: language.agent_code,
        options: {
            display: true
        }
    },
    {
        name: "agent_name",
        label: language.agent_name,
        options: {
            display: true
        }
    },
    {
        name: "customer_code",
        label: language.outlet_code,
        options: {
            display: true
        }
    },
    {
        name: "customer_name",
        label: language.outlet_name,
        options: {
            display: true
        }
    },
    {
        name: "checkin_time",
        label: language.check_in,
        options: {
            display: true
        }
    },
    {
        name: "checkout_time",
        label: language.check_out,
        options: {
            display: true
        }
    },
    {
        name: "survey_form_title",
        label: language.survey_title,
        options: {
            display: true
        }
    },
	{
		name: "submitted_at",
		label: language.submission_date,
		options: {
			display: true
		}
	},
];

const splitDateTime = (value) => {
	const [date = '', ...time] = (value || '').split(' ');
	return {date, time: time.join(' ')};
};

export default function SurveyResponse() {
	const commonStyle = useCommonStyles();
	const classes = useStyles();
	const singleton = PersistantData.getInstance();
	const [gState, setGState] = useContext(AppContext);
	var {translation: language, client} = gState;
	if (typeof (language) === 'undefined') {
		language = singleton.getlang()
	}

	const [cookies, setCookie] = useCookieHook([ck_u_username, ck_u_password]);
	const {enqueueSnackbar, closeSnackbar} = useSnackbar();

	const [splist, setSPlist] = useState([]);
	const [surveyTitleList, setSurveyTitleList] = useState([]);
	const [csrActivityList, setCsrActivityList] = useState([]);
	const [tableHeader, setTableHeader] = useState([]);
	const { columns: preferredColumns, onColumnViewChange: onPrefColumnViewChange } = useColumnPreference('RSurveyResponse', tableHeader, client);

	const [csrActivityDateRange, setCsrActivityDateRange] = useState({});
	const [openCsrActivityDateDoc, setOpenCsrActivityDateDoc] = useState(false);
	const [csrActivitySpView, setCsrActivitySpView] = useState(false);
	const [surveyTitleView, setSurveyTitleView] = useState(false);
	const [csrActivitySpSelect, setCsrActivitySpSelected] = useState(empty);
	const [surveyTitleSelect, setSurveyTitleSelect] = useState(empty);
	const [csrActivitySalesperson, setCsrActivitySalesperson] = useState(empty);
	const [surveyTitleName, setSurveyTitleName] = useState(empty);
	const [outletList, setOutletList] = useState([]);
	const [outletView, setOutletView] = useState(false);
	const [outletSelect, setOutletSelect] = useState(empty);
	const [outletName, setOutletName] = useState(empty);
	const [detailDialog, setDetailDialog] = useState(false);
	const [selectedRowData, setSelectedRowData] = useState({});
	const [selectedRowDataResponseDetails, setSelectedRowDataResponseDetails] = useState({});
	const [photoViewer, setPhotoViewer] = useState({open: false, images: [], index: 0});
	const [pdfLoading, setPdfLoading] = useState(false);

	useEffect(() => {
		if (JString(gState.client).isValid()) {
			getSalesmanList(gState.client);
			getSurveyTitleList(gState.client);
			getOutletList(gState.client);
		}
		setTableHeader(tableHead(language));
	}, [gState.client, gState.translation]);

	const snack = (msg, type = 'success') => {
		enqueueSnackbar(msg, {
			variant: type,
			preventDuplicate: true,
			autoHideDuration: type === 'success' ? 2000 : 3000
		});
	}

	const getSalesmanList = (_client = client) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		API_Service.get(`${req_salesman}${parameters}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < extraData.length; idx++) {
					const {name, login_id, login, login_status} = extraData[idx];
					_data.push({name: name, secondary: login, value: login_id, status: parseInt(login_status)});
				}
				setSPlist(_data);
			}
		});
	}

	const getSurveyTitleList = (_client = client) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		API_Service.get(`${req_survey_forms}${parameters}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				var _data = [];
				const forms = [...(extraData.not_closed_list || []), ...(extraData.closed_list || [])];
				for (let idx = 0; idx < forms.length; idx++) {
					const {title, id, status} = forms[idx];
					if (status !== 'active' && status !== 'closed') continue;
					_data.push({name: title, secondary:id, value: id, status: status === 'active' ? 1 : 0});
				}
				setSurveyTitleList(_data);
			}
		});
	}

	const getOutletList = (_client = client) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		API_Service.get(`${req_cust}${parameters}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData, message} = data;
			if (parseInt(result) === 1) {
				const {customer = [], inactive_customer = []} = extraData;
				var _data = [];
				for (let idx = 0; idx < customer.length; idx++) {
					const {cust_id, cust_code, cust_company_name} = customer[idx];
					_data.push({name: cust_company_name, secondary: cust_code, value: cust_id, status: 1});
				}
				for (let idx = 0; idx < inactive_customer.length; idx++) {
					const {cust_id, cust_code, cust_company_name} = inactive_customer[idx];
					_data.push({name: cust_company_name, secondary: cust_code, value: cust_id, status: 0});
				}
				setOutletList(_data);
			} else {
				snack(message || language.no_data, 'error');
			}
		}).catch(() => {
			snack(language.network_error, 'error');
		});
	}

	const getCsrActivityData = (_client = client, shouldExport = false) => {
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(csrActivityDateRange)) {
			st_date = format(csrActivityDateRange.startDate, defDateFormat);
			st_date_to = format(csrActivityDateRange.endDate, defDateFormat);
		}
		var parameters = {
			client: client,
			date_from: st_date,
			date_to: st_date_to,
			salespersonId: csrActivitySpSelect,
			surveyTitleId: surveyTitleSelect,
			outletId: outletSelect,
			username: cookies(ck_u_username),
            export: shouldExport,
		};
		if (gState.company) {
			parameters.company = gState.company;
		}
		if (shouldExport) {
			parameters.columns = (preferredColumns.length > 0 ? preferredColumns : tableHeader)
				.filter(col => col.options && col.options.display !== false && col.options.display !== 'false')
				.map(col => col.name)
				.join(',');
		}

		const param = axiosURIencode(parameters);
		if (shouldExport == false) {
			API_Service.get(`${req_survey_submission}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData, message} = data;
			if (result) {
				setCsrActivityList(extraData);
				snack('Survey Response data loaded successfully', 'success');
			} else {
				setCsrActivityList([]);
				snack(message || language.no_data, 'warning');
			}
		}).catch(error => {
			console.error('Survey Response API Error:', error);
			setCsrActivityList([]);
			snack('Failed to load Survey Response data', 'error');
		});
		} else {
			API_Service.get(`${req_survey_submission}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
				const {result, extraData, message} = data;
				if (result) {
					if (extraData && extraData.url) {
						const link = document.createElement('a');
						link.href = extraData.url;
						link.download = extraData.filename || 'CSR_Activities_Report.xlsx';
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						
						snack(message || 'Excel report has been successfully downloaded', 'success');
					} else {
						snack('Failed to download Excel report - No download URL provided', 'error');
					}
				} else {
					snack(message, 'error');
				}
			}).catch(error => {
				console.error('Excel export API Error:', error);
				snack('Failed to download Excel report', 'error');
			});
		}
	}

	const CsrActivitySPViewClick = () => {
		setCsrActivitySpView(true);
	}

	const surveyTitleViewClick = () => {
		setSurveyTitleView(true);
	}

	const CsrActivitySPViewClose = (newValue) => {
		setCsrActivitySpView(false);
		if (newValue) {
			var spvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spvalue += newValue[i].value;
				} else {
					spvalue += newValue[i].value + ",";
				}
			}
			setCsrActivitySpSelected(spvalue);

			var spname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spname += newValue[i].name;
				} else {
					spname += newValue[i].name + ",";
				}
			}
			setCsrActivitySalesperson(spname);
		}
	}

	const surveyTitleViewClose = (newValue) => {
		if (newValue) {
			var surveyTitleValue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					surveyTitleValue += newValue[i].value;
				} else {
					surveyTitleValue += newValue[i].value + ",";
				}
			}
			setSurveyTitleSelect(surveyTitleValue);

			var surveyTitleName = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					surveyTitleName += newValue[i].name;
				} else {
					surveyTitleName += newValue[i].name + ",";
				}
			}
			setSurveyTitleName(surveyTitleName);
		}

		setSurveyTitleView(false);
	}

	const outletViewClick = () => {
		setOutletView(true);
	}

	const outletViewClose = (newValue) => {
		setOutletView(false);
		if (newValue) {
			var outletValue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i === newValue.length - 1) {
					outletValue += newValue[i].value;
				} else {
					outletValue += newValue[i].value + ",";
				}
			}
			setOutletSelect(outletValue);

			var outletNames = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i === newValue.length - 1) {
					outletNames += newValue[i].name;
				} else {
					outletNames += newValue[i].name + ",";
				}
			}
			setOutletName(outletNames);
		}
	}

	const getCsrActivityDate = () => {
		return !_.isEmpty(csrActivityDateRange) ? moment(csrActivityDateRange.startDate).format('DD MMMM YYYY') + " / " + moment(csrActivityDateRange.endDate).format('DD MMMM YYYY') : moment(new Date()).format('DD MMMM YYYY') + " / " + moment(new Date()).format('DD MMMM YYYY');
	}

	const handleRowClick = (rowData, rowMeta) => {
		const selectedData = csrActivityList[rowMeta.dataIndex];
		setSelectedRowData(selectedData);
		setSelectedRowDataResponseDetails(selectedData.response_details);
		setDetailDialog(true);
	}

	const handleCloseDetailDialog = () => {
		setDetailDialog(false);
		setSelectedRowData({});
		setSelectedRowDataResponseDetails({});
	}

	const openPhotoViewer = (images, index) => {
		setPhotoViewer({open: true, images: images, index: index});
	}

	const closePhotoViewer = () => {
		setPhotoViewer(prev => ({...prev, open: false}));
	}

	const replaceAnswerUrl = (answer, oldUrl, newUrl) => {
		if (Array.isArray(answer)) {
			return answer.map(url => url === oldUrl ? newUrl : url);
		}
		if (typeof answer === 'string') {
			return answer.split(oldUrl).join(newUrl);
		}
		return answer;
	}

	const savePhotoRotation = (src, angle) => {
		const formdata = new FormData();
		formdata.append('submission_id', selectedRowData.id);
		formdata.append('image_url', src);
		formdata.append('angle', angle);
		return API_Service.post(req_survey_rotateimage, formdata, axiosDefaultConfig(client)).then(({data}) => {
			const {result, extraData, message} = data;
			if (parseInt(result) === 1 && extraData && extraData.image_url) {
				const newUrl = extraData.image_url;
				const details = selectedRowDataResponseDetails.map(item => ({...item, answer: replaceAnswerUrl(item.answer, src, newUrl)}));
				// Mutate the row in place: a new list array would make MUIDataTable rebuild and lose its sort/page.
				selectedRowData.response_details = details;
				setSelectedRowDataResponseDetails(details);
				setPhotoViewer(prev => ({...prev, images: prev.images.map(url => url === src ? newUrl : url)}));
				snack(language.saved, 'success');
				return true;
			}
			snack(message || language.update_fail, 'error');
			return false;
		}).catch(() => {
			snack(language.network_error, 'error');
			return false;
		});
	}

	const downloadAsPDF = (selectedData) => {
        var id = selectedData.id;
        var url = `${req_survey_submission_report_download}?id=${id}`;
        setPdfLoading(true);
        API_Service.get(url, axiosDefaultConfig(client)).then(({data}) => {
            const {result, extraData} = data;
            if (result == true) {
                snack('PDF report has been successfully downloaded', 'success');
                var base64 = extraData.base64;
                var htmlContent = atob(base64);
                
                var newWindow = window.open('', '_blank');
                if (newWindow) {
                    newWindow.document.open();
                    newWindow.document.write(htmlContent);
                    newWindow.document.close();
                } else {
                    snack('Failed to open new window, please check browser popup settings', 'warning');
                }
            } else {
                snack('Failed to download PDF report', 'error');
            }
        }).catch(error => {
            console.error('Error downloading PDF report:', error);
            snack('Failed to download PDF report', 'error');
        }).finally(() => setPdfLoading(false));
    }

	const checkinTime = splitDateTime(selectedRowData.checkin_time);
	const checkoutTime = splitDateTime(selectedRowData.checkout_time);

	const renderQuestionType = (type) => {
		const meta = {
			rating: {label: language.qtype_rating, Icon: StarRateRoundedIcon},
			file_upload: {label: language.qtype_photos, Icon: PhotoLibraryOutlinedIcon},
			multiple_choice: {label: language.qtype_choice, Icon: PlaylistAddCheckIcon}
		}[type] || {label: language.qtype_text, Icon: SubjectIcon};
		const TypeIcon = meta.Icon;
		return (
			<span className={classes.qType}>
				<TypeIcon/>
				<span className={classes.qTypeLabel}>{meta.label}</span>
			</span>
		);
	}

	const renderAnswer = (item) => {
		if (item.question_type === 'rating') {
			const score = parseFloat(item.answer) || 0;
			return (
				<div className={classes.rating}>
					<Rating value={score} max={5} readOnly size="medium"/>
					<span className={classes.rScore}><b>{score.toFixed(1)}</b> / 5</span>
				</div>
			);
		}
		if (item.question_type === 'file_upload') {
			let images = [];
			try {
				images = Array.isArray(item.answer) ? item.answer : JSON.parse(item.answer || '[]');
			} catch (e) {
				return (
					<Typography variant="body2" className={classes.ansText}>
						{item.answer || language.no_image_available}
					</Typography>
				);
			}
			if (!images.length) {
				return (
					<div className={classes.ansEmpty}><InfoOutlinedIcon/>{language.no_image_available}</div>
				);
			}
			return (
				<div className={classes.photos}>
					<div className={classes.photoCount}>
						<PhotoLibraryOutlinedIcon/>{images.length} {language.qtype_photos}
					</div>
					{images.map((imageUrl, imgIndex) => (
						<div key={imgIndex} className={classes.thumb} onClick={() => openPhotoViewer(images, imgIndex)}>
							<img src={imageUrl} alt={`${language.photo} ${imgIndex + 1}`}/>
							<span className={classes.thumbOverlay}><ZoomInIcon/></span>
						</div>
					))}
				</div>
			);
		}
		if (item.question_type === 'multiple_choice') {
			let choices = [];
			try {
				choices = Array.isArray(item.answer) ? item.answer : JSON.parse(item.answer || '[]');
			} catch (e) {
				return item.answer
					? <Typography variant="body1" className={classes.ansText}>{item.answer}</Typography>
					: <div className={classes.ansEmpty}><InfoOutlinedIcon/>{language.no_answer}</div>;
			}
			if (!choices.length) {
				return <div className={classes.ansEmpty}><InfoOutlinedIcon/>{language.no_answer}</div>;
			}
			return (
				<div className={classes.choices}>
					{choices.map((choice, choiceIndex) => (
						<Chip key={choiceIndex} size="small" className={classes.choiceChip} icon={<DoneRoundedIcon/>} label={choice}/>
					))}
				</div>
			);
		}
		return item.answer
			? <Typography variant="body1" className={classes.ansText}>{item.answer}</Typography>
			: <div className={classes.ansEmpty}><InfoOutlinedIcon/>{language.no_answer}</div>;
	}

	return (
		<div>
			<div className={classes.viewInRow}>
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => CsrActivitySPViewClick()}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{csrActivitySalesperson ? _.truncate(csrActivitySalesperson, {length: 20}) : language.salesperson}
					</Typography>
				</Button>
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => surveyTitleViewClick()}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{surveyTitleName ? _.truncate(surveyTitleName, {length: 20}) : language.survey_title}
					</Typography>
				</Button>
				<Button
					className={classes.filterBtn}
					variant="outlined"
					onClick={outletViewClick}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{outletName ? _.truncate(outletName, {length: 20}) : language.customer}
					</Typography>
				</Button>
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setOpenCsrActivityDateDoc(true)}>
					<Typography className={commonStyle.searchBtnFont}>
						{getCsrActivityDate()}
					</Typography>
				</Button>

				<Button
					size="small"
					color="primary"
					variant={'contained'}
					onClick={() => getCsrActivityData(client, false)}>
					<Typography className={commonStyle.searchBtnFont}>
						{language.view}
					</Typography>
				</Button>
				<div style={{width: 10}}/>
				<Button
					size="small"
					color="primary"
					variant={'contained'}
					onClick={() => getCsrActivityData(client, true)}>
					<Typography className={commonStyle.searchBtnFont}>
						{language.export || 'Survey Response Report'}
					</Typography>
				</Button>
			</div>
			<div style={{height: 20}}/>
			{
				csrActivityList.length > 0 && (
					<MUIDataTable
						title="Survey Response List"
						data={csrActivityList}
						columns={preferredColumns}
						options={{
							search: false,
							print: false,
							filter: false,
							download: false,
							selectableRows: 'none',
							rowsPerPage: 25,
							rowsPerPageOptions: [25, 40, 65, 100],
							responsive: 'simple',
							onRowClick: handleRowClick,
							onColumnViewChange: onPrefColumnViewChange,
						}}
					/>
				)
			}

			<VirtualListCB
				open={csrActivitySpView}
				setClose={data => CsrActivitySPViewClose(data)}
				title={language.salesperson}
				data={splist}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={surveyTitleView}
				setClose={data => surveyTitleViewClose(data)}
				title={language.survey_title}
				data={surveyTitleList}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={outletView}
				setClose={outletViewClose}
				title={language.customer}
				data={outletList}
				language={language}
				filteration={1}
			/>

			<DateRangePickerModal
				setPositive={range => {
					setCsrActivityDateRange(range);
					setOpenCsrActivityDateDoc(false)
				}}
				setNegative={() => {
					setOpenCsrActivityDateDoc(false)
				}}
				setClose={() => {
					setOpenCsrActivityDateDoc(false)
				}}
				open={openCsrActivityDateDoc}
				message={language.date_range}
				positive={language.ok}
			/>

			<Dialog
				open={detailDialog}
				onClose={handleCloseDetailDialog}
				maxWidth="lg"
				fullWidth
				classes={{paper: classes.dialogPaper}}>
				<div className={classes.dhead}>
					<span className={classes.headBadge}><AssignmentOutlinedIcon/></span>
					<div className={classes.headText}>
						<Typography variant="h6" className={classes.headTitle}>
							{language.survey_response_details}
						</Typography>
						<Typography variant="body2" className={classes.headSub}>
							{selectedRowData.survey_form_title || '-'}
						</Typography>
					</div>
					<Button
						size="small"
						variant="contained"
						className={classes.btnPrimary}
						onClick={() => downloadAsPDF(selectedRowData)}
						disabled={pdfLoading}
						startIcon={pdfLoading ? <CircularProgress size={16} color="inherit"/> : <GetAppIcon/>}>
						{language.download_pdf}
					</Button>
					<IconButton size="small" className={classes.closeBtn} onClick={handleCloseDetailDialog}>
						<CloseIcon/>
					</IconButton>
				</div>
				<DialogContent className={classes.dbody}>
					<div className={classes.strip}>
						<div className={classes.cell}>
							<div className={classes.cellLabel}><PersonOutlineIcon/>{language.salesperson}</div>
							<Typography variant="body2" className={classes.cellValue}>{selectedRowData.agent_name || '-'}</Typography>
							{selectedRowData.agent_code ? <span className={classes.cellCode}>{selectedRowData.agent_code}</span> : null}
						</div>
						<div className={classes.cell}>
							<div className={classes.cellLabel}><LocationOnOutlinedIcon/>{language.customer}</div>
							<Tooltip title={selectedRowData.customer_name || ''}>
								<Typography variant="body2" className={`${classes.cellValue} ${classes.cellValueClamp}`}>{selectedRowData.customer_name || '-'}</Typography>
							</Tooltip>
							{selectedRowData.customer_code ? <span className={classes.cellCode}>{selectedRowData.customer_code}</span> : null}
						</div>
						<div className={classes.cell}>
							<div className={classes.cellLabel}><CheckInIcon/>{language.check_in}</div>
							<Typography variant="body2" className={classes.cellValue}>{checkinTime.date || '-'}</Typography>
							{checkinTime.time ? <span className={classes.cellSub}>{checkinTime.time}</span> : null}
						</div>
						<div className={classes.cell}>
							<div className={classes.cellLabel}><CheckOutIcon/>{language.check_out}</div>
							<Typography variant="body2" className={classes.cellValue}>{checkoutTime.date || '-'}</Typography>
							{checkoutTime.time ? <span className={classes.cellSub}>{checkoutTime.time}</span> : null}
						</div>
					</div>
					{selectedRowDataResponseDetails.length > 0 && selectedRowDataResponseDetails.map((item, index) => (
						<Card key={index} elevation={0} className={classes.qCard}>
							<div className={classes.qHead}>
								<span className={classes.qNum}>{language.question_abbr}{index + 1}</span>
								<Typography variant="subtitle1" className={classes.qText}>
									{item.question}
								</Typography>
								{renderQuestionType(item.question_type)}
							</div>
							<div className={classes.qAns}>
								{renderAnswer(item)}
							</div>
						</Card>
					))}
				</DialogContent>
			</Dialog>

			<PhotoViewer
				open={photoViewer.open}
				images={photoViewer.images}
				index={photoViewer.index}
				onClose={closePhotoViewer}
				onSaveRotation={savePhotoRotation}
			/>
		</div>
	)
}